import * as Yup from "yup";

export interface IRegularizationMeterRetirementSetFormSchema {
  info: {
    district: string;
    description: string;
    requestCodes: string[];
  };
}

export const InfoFormSchema = Yup.object().shape({
  district: Yup.string().notRequired(),
  description: Yup.string().required(),
  requestCodes: Yup.array()
    .of(Yup.string())
    .min(1, "At least one regularization installation service order code is required")
    .required("At least one regularization installation service order code is required"),
});
